global.BACKEND_URL = "https://ps-app-test.herokuapp.com";
//global.BACKEND_URL = "http://localhost:8080";
//global.BACKEND_URL = "http://192.168.0.205:8090";
global.APP_SEARCH_BACKEND_URL = "http://psoffice.dscloud.mobi:3002";
//global.APP_SEARCH_BACKEND_URL = "http://192.168.0.205:3002";
